import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * "What's included" checklist that follows the selected variant.
 *
 * Horizon's variant picker fetches the section again on every selection but
 * morphs only itself. Blocks that depend on the variant listen for the
 * product-select event on their section and take their own new markup from
 * the fetched document — `assets/product-price.js` is the reference. This does
 * the same: find the matching element in the new HTML and morph into it, which
 * also carries over the `hidden` attribute when the new variant has no list.
 *
 * @extends {Component}
 */
export default class EmberkIncludes extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = String(detail.newProduct.id);
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = detail.html.querySelector(`emberk-includes-component[data-block-id="${this.dataset.blockId}"]`);
        if (!(next instanceof Element)) return;

        morph(this, next);
      })
      .catch(() => {});
  };
}

if (!customElements.get('emberk-includes-component')) {
  customElements.define('emberk-includes-component', EmberkIncludes);
}
